import React from 'react';

export const UploadIcon: React.FC<{className?: string}> = ({className}) => (
  <svg className={className || "w-12 h-12 text-slate-500"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
  </svg>
);

export const DownloadIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
    </svg>
);

export const RotateCwIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M23 4v6h-6"></path>
        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
    </svg>
);

export const RotateCcwIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 4v6h6"></path>
        <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
    </svg>
);

export const ZipIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
    </svg>
);

export const ClearIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
    </svg>
);

export const TrashIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
    </svg>
);

export const LayersIcon: React.FC<{className?: string}> = ({className}) => (
  <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

export const SwapIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-6 h-6"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path>
    </svg>
);

export const SearchIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5 text-slate-400"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
    </svg>
);

export const ChevronDownIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
    </svg>
);

export const ChevronLeftIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
    </svg>
);

export const ChevronRightIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
    </svg>
);

export const TextIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-6 h-6"} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.613 18H14.387L15.3 15H8.7L9.613 18ZM12 4.667L6.44 14H8.313L9.133 12H14.867L15.687 14H17.56L12 4.667ZM10.16 11L12 7.04L13.84 11H10.16Z" />
    </svg>
);

export const PencilIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-6 h-6"} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
         <path d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"/>
    </svg>
);

export const ImageIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-6 h-6"} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
    </svg>
);

export const ArrowLeftIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-6 h-6"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
    </svg>
);

export const ArrowRightIcon: React.FC<{className?: string}> = ({className}) => (
     <svg className={className || "w-6 h-6"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
    </svg>
);

export const UndoIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-6 h-6"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 15l-3-3m0 0l3-3m-3 3h8a5 5 0 000-10H9"></path>
    </svg>
);

export const RedoIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-6 h-6"} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 15l3-3m0 0l-3-3m3 3H5a5 5 0 000 10h8"></path>
    </svg>
);

export const CursorArrowIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-6 h-6"} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.64 21.97l-1.05-4.37 4.54-1.25-10.1-10.1 3.87 11.39 2.74-5.67z"/>
    </svg>
);

export const BoldIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"/>
    </svg>
);

export const ItalicIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"/>
    </svg>
);

export const UnderlineIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"/>
    </svg>
);

export const TextBackgroundIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M6 14h12v2H6z"/>
        <path d="M11 5L5.5 15h2.2l1.1-3h4.4l1.1 3h2.2L13 5h-2zm-1.35 7l1.85-5.19L13.35 12h-3.7z"/>
    </svg>
);

export const LineIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <line x1="4" y1="12" x2="20" y2="12" />
    </svg>
);

export const CheckIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
);

export const OcrIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 3H5a2 2 0 0 0-2 2v2" />
        <path d="M17 3h2a2 2 0 0 1 2 2v2" />
        <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
        <path d="M17 21h2a2 2 0 0 0 2-2v-2" />
        <circle cx="12" cy="12" r="3" />
        <path d="M12 7v2" />
        <path d="M12 15v2" />
        <path d="M7 12h2" />
        <path d="M15 12h2" />
    </svg>
);

export const CopyIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
);

export const XIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);

export const WarningIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
);

export const LinkIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
);

export const DocumentTextIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
    </svg>
);

export const VolumeIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" />
    </svg>
);

export const DragHandleIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="5" r="1.5" />
        <circle cx="9" cy="12" r="1.5" />
        <circle cx="9" cy="19" r="1.5" />
        <circle cx="15" cy="5" r="1.5" />
        <circle cx="15" cy="12" r="1.5" />
        <circle cx="15" cy="19" r="1.5" />
    </svg>
);

export const FillIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2l4.5 4.5L7 16l-4.5-4.5L12 2z" />
        <path d="M18 12l2.5 2.5-4.5 4.5-2.5-2.5L18 12z" />
        <path d="M3 22h18" />
    </svg>
);

export const ZoomInIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
        <line x1="11" y1="8" x2="11" y2="14" />
        <line x1="8" y1="11" x2="14" y2="11" />
    </svg>
);

export const ZoomOutIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
        <line x1="8" y1="11" x2="14" y2="11" />
    </svg>
);

export const OpacityIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 2a10 10 0 0 1 0 20z" fill="currentColor" fillOpacity="0.3" />
    </svg>
);

export const RectangleIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    </svg>
);

export const PasteIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
    </svg>
);

export const EyeIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

export const EyeOffIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
);

export const UnlockIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 9.9-1" />
    </svg>
);

export const ScissorsIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6" cy="6" r="3" />
        <circle cx="6" cy="18" r="3" />
        <line x1="20" y1="4" x2="8.12" y2="15.88" />
        <line x1="14.47" y1="14.48" x2="20" y2="20" />
        <line x1="8.12" y1="8.12" x2="12" y2="12" />
    </svg>
);

export const SparklesIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3l1.91 5.89L20 10.8l-5.89 1.91L12 18.6l-1.91-5.89L4.2 10.8l5.89-1.91z" />
        <path d="M5 3l.64 1.96L7.6 5.6l-1.96.64L5 8.2l-.64-1.96L2.4 5.6l1.96-.64z" />
        <path d="M19 16l.64 1.96 1.96.64-1.96.64L19 21.2l-.64-1.96-1.96-.64 1.96-.64z" />
    </svg>
);

export const MicrophoneIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-10 h-10"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <line x1="12" y1="19" x2="12" y2="23" />
        <line x1="8" y1="23" x2="16" y2="23" />
    </svg>
);

export const GlobeIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-6 h-6"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
);

export const ZoomFitIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 7V5a2 2 0 0 1 2-2h2" />
        <path d="M17 3h2a2 2 0 0 1 2 2v2" />
        <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
        <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
        <rect x="9" y="9" width="6" height="6" />
    </svg>
);

export const BrightnessIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="5" />
        <line x1="12" y1="1" x2="12" y2="3" />
        <line x1="12" y1="21" x2="12" y2="23" />
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
        <line x1="1" y1="12" x2="3" y2="12" />
        <line x1="21" y1="12" x2="23" y2="12" />
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
);

export const ContrastIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 18a6 6 0 1 0 0-12v12z" fill="currentColor" />
    </svg>
);

export const SaturationIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
    </svg>
);

export const ResetIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 4v6h6" />
        <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
    </svg>
);

export const SunIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-7 h-7"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="5" />
        <line x1="12" y1="1" x2="12" y2="3" />
        <line x1="12" y1="21" x2="12" y2="23" />
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
        <line x1="1" y1="12" x2="3" y2="12" />
        <line x1="21" y1="12" x2="23" y2="12" />
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
);

export const MoonIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-7 h-7"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
);

export const TwitterIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.84 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
    </svg>
);

export const GithubIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
    </svg>
);

export const HeartIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-8 h-8 text-rose-500"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
);

export const LockClosedIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-8 h-8 text-cyan-600"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
);

export const CodeBracketIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-8 h-8 text-indigo-500"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <polyline points="16 18 22 12 16 6" />
        <polyline points="8 6 2 12 8 18" />
    </svg>
);

export const BackgroundRemoverIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" />
        <path d="M12 12h9v9h-9z" />
        <line x1="16" y1="16" x2="22" y2="22" />
        <line x1="22" y1="16" x2="16" y2="22" />
    </svg>
);

export const MenuIcon: React.FC<{className?: string}> = ({className}) => (
  <svg className={className || "w-6 h-6"} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

export const CopilotIcon: React.FC<{className?: string}> = ({className}) => (
  <svg className={className || "w-8 h-8"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L14.4 7.6L20 10L14.4 12.4L12 18L9.6 12.4L4 10L9.6 7.6L12 2Z" fill="currentColor"/>
    <path d="M19 16L20.2 18.8L23 20L20.2 21.2L19 24L17.8 21.2L15 20L17.8 18.8L19 16Z" fill="currentColor" opacity="0.85"/>
    <path d="M5 16L6 18.5L8.5 19.5L6 20.5L5 23L4 20.5L1.5 19.5L4 18.5L5 16Z" fill="currentColor" opacity="0.7"/>
  </svg>
);

export const CropIcon: React.FC<{className?: string}> = ({className}) => (
  <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.13 1L6 16a2 2 0 002 2h15" />
    <path d="M1 6.13L16 6a2 2 0 012 2v15" />
  </svg>
);

// --- Colorful Variations ---

const ColorfulIcon = (Icon: React.FC<{className?: string}>, bg: string) => ({className}: {className?: string}) => (
    <div className={`p-2 rounded-xl text-white ${bg} shadow-sm`}>
        <Icon className={className || "w-6 h-6"} />
    </div>
);

export const ColorfulPdfImageIcon = ColorfulIcon(ImageIcon, "bg-red-500");
export const ColorfulPdfEditorIcon = ColorfulIcon(PencilIcon, "bg-blue-600");
export const ColorfulCurrencyIcon = ColorfulIcon(SwapIcon, "bg-green-500");
export const ColorfulHashIcon = ColorfulIcon(CodeBracketIcon, "bg-slate-600");
export const ColorfulPdfSecurityIcon = ColorfulIcon(LockClosedIcon, "bg-orange-600");
export const ColorfulPdfUnlockIcon = ColorfulIcon(UnlockIcon, "bg-teal-600");
export const ColorfulImageEditorIcon = ColorfulIcon(SparklesIcon, "bg-pink-500");
export const ColorfulWatermarkIcon = ColorfulIcon(OpacityIcon, "bg-indigo-500");
export const ColorfulImageWatermarkIcon = ColorfulIcon(OpacityIcon, "bg-purple-500");
export const ColorfulHtmlIcon = ColorfulIcon(CodeBracketIcon, "bg-orange-500");
export const ColorfulPdfRepairIcon = ColorfulIcon(ResetIcon, "bg-emerald-600");
export const ColorfulPdfCropIcon = ColorfulIcon(ZoomFitIcon, "bg-cyan-600");
export const ColorfulPptIcon = ColorfulIcon(ImageIcon, "bg-orange-700");
export const ColorfulPdfSignIcon = ColorfulIcon(PencilIcon, "bg-blue-700");
export const ColorfulPdfSplitIcon = ColorfulIcon(ScissorsIcon, "bg-red-600");
export const ColorfulJsonIcon = ColorfulIcon(CodeBracketIcon, "bg-amber-600");
export const ColorfulHtmlBeautifierIcon = ColorfulIcon(SparklesIcon, "bg-sky-600");
export const ColorfulFacebookIcon = ColorfulIcon(DownloadIcon, "bg-blue-800");
export const ColorfulOcrIcon = ColorfulIcon(OcrIcon, "bg-amber-500");
export const ColorfulImageCompressorIcon = ColorfulIcon(DownloadIcon, "bg-indigo-600");
export const ColorfulImageFormatConverterIcon = ColorfulIcon(SwapIcon, "bg-violet-600");
export const ColorfulQrCodeIcon = ColorfulIcon(SearchIcon, "bg-cyan-500");
export const ColorfulBarcodeIcon = ColorfulIcon(CodeBracketIcon, "bg-slate-700");
export const ColorfulPasswordIcon = ColorfulIcon(LockClosedIcon, "bg-rose-600");
export const ColorfulIpLocationIcon = ColorfulIcon(GlobeIcon, "bg-blue-500");
export const ColorfulPassportPhotoIcon = ColorfulIcon(ImageIcon, "bg-emerald-500");
export const ColorfulAgeCalculatorIcon = ColorfulIcon(HeartIcon, "bg-pink-600");
export const ColorfulColorPickerIcon = ColorfulIcon(OpacityIcon, "bg-amber-600");
export const ColorfulEmojiRemoverIcon = ColorfulIcon(SparklesIcon, "bg-indigo-600");
export const ColorfulTimezoneConverterIcon = ColorfulIcon(GlobeIcon, "bg-sky-500");
export const ColorfulImageCropIcon = ColorfulIcon(CropIcon, "bg-cyan-600");
export const ColorfulImageUpscalerIcon = ColorfulIcon(ZoomFitIcon, "bg-teal-600");
export const ColorfulCalculatorIcon = ColorfulIcon(CodeBracketIcon, "bg-slate-800");
export const ColorfulUnitConverterIcon = ColorfulIcon(SwapIcon, "bg-orange-600");
export const ColorfulTextToSpeechIcon = ColorfulIcon(MicrophoneIcon, "bg-rose-500");
export const ColorfulVoiceToTextIcon = ColorfulIcon(MicrophoneIcon, "bg-indigo-500");
export const ColorfulTextEditorIcon = ColorfulIcon(PencilIcon, "bg-blue-500");
export const ColorfulHashtagIcon = ColorfulIcon(SearchIcon, "bg-cyan-600");
export const ColorfulWordCounterIcon = ColorfulIcon(TextIcon, "bg-teal-500");
export const ColorfulIcoConverterIcon = ColorfulIcon(ImageIcon, "bg-orange-500");
export const ColorfulIcoToPngIcon = ColorfulIcon(ImageIcon, "bg-blue-400");
export const ColorfulArticleRewriterIcon = ColorfulIcon(SparklesIcon, "bg-purple-600");
export const ColorfulKeywordsSuggestionIcon = ColorfulIcon(SearchIcon, "bg-lime-600");
export const ColorfulPhpEncoderIcon = ColorfulIcon(CodeBracketIcon, "bg-blue-800");
export const ColorfulPhpDecoderIcon = ColorfulIcon(CodeBracketIcon, "bg-sky-700");
export const ColorfulRemoveLineBreaksIcon = ColorfulIcon(ScissorsIcon, "bg-slate-500");
export const ColorfulFlipImageIcon = ColorfulIcon(SwapIcon, "bg-indigo-400");
export const ColorfulRotateImageIcon = ColorfulIcon(RotateCwIcon, "bg-violet-500");
export const ColorfulYoutubeThumbnailDownloaderIcon = ColorfulIcon(ImageIcon, "bg-red-600");
export const ColorfulYoutubeTrendIcon = ColorfulIcon(SparklesIcon, "bg-red-700");
export const ColorfulYoutubeTagExtractorIcon = ColorfulIcon(SearchIcon, "bg-red-800");
export const ColorfulYoutubeTagGeneratorIcon = ColorfulIcon(PencilIcon, "bg-red-500");
export const ColorfulYoutubeHashtagExtractorIcon = ColorfulIcon(SearchIcon, "bg-red-900");
export const ColorfulYoutubeHashtagGeneratorIcon = ColorfulIcon(SparklesIcon, "bg-red-400");
export const ColorfulYoutubeTitleExtractorIcon = ColorfulIcon(TextIcon, "bg-rose-600");
export const ColorfulYoutubeTitleGeneratorIcon = ColorfulIcon(PencilIcon, "bg-rose-500");
export const ColorfulYoutubeDescriptionExtractorIcon = ColorfulIcon(TextIcon, "bg-rose-800");
export const ColorfulFreeStockPhotoSearchIcon = ColorfulIcon(SearchIcon, "bg-green-600");
export const ColorfulHtmlEncoderIcon = ColorfulIcon(CodeBracketIcon, "bg-orange-600");
export const ColorfulHtmlDecoderIcon = ColorfulIcon(CodeBracketIcon, "bg-amber-500");
export const ColorfulHtmlErrorFixerIcon = ColorfulIcon(ResetIcon, "bg-emerald-500");
export const ColorfulLengthConverterIcon = ColorfulIcon(SwapIcon, "bg-blue-600");
export const ColorfulWeightConverterIcon = ColorfulIcon(SwapIcon, "bg-green-600");
export const ColorfulTemperatureConverterIcon = ColorfulIcon(SwapIcon, "bg-orange-600");
export const ColorfulTimeConverterIcon = ColorfulIcon(GlobeIcon, "bg-indigo-600");
export const ColorfulDigitalStorageConverterIcon = ColorfulIcon(CodeBracketIcon, "bg-slate-700");
export const ColorfulSpeedConverterIcon = ColorfulIcon(SwapIcon, "bg-rose-500");
export const ColorfulLoanCalculatorIcon = ColorfulIcon(CodeBracketIcon, "bg-green-700");
export const ColorfulPercentageCalculatorIcon = ColorfulIcon(CodeBracketIcon, "bg-blue-700");
export const ColorfulContactIcon = ColorfulIcon(PencilIcon, "bg-slate-900");
export const ColorfulMemeGeneratorIcon = ColorfulIcon(ImageIcon, "bg-pink-600");
export const ColorfulSleepCalculatorIcon = ColorfulIcon(HeartIcon, "bg-indigo-700");
export const ColorfulAboutIcon = ColorfulIcon(CopilotIcon, "bg-cyan-700");
export const ColorfulXmlToJsonIcon = ColorfulIcon(CodeBracketIcon, "bg-amber-600");
export const ColorfulXmlToPdfIcon = ColorfulIcon(CodeBracketIcon, "bg-amber-600");
export const ColorfulCsvToJsonIcon = ColorfulIcon(CodeBracketIcon, "bg-teal-600");
export const ColorfulBase64ToImageIcon = ColorfulIcon(ImageIcon, "bg-indigo-500");
export const ColorfulPdfFormFillerIcon = ColorfulIcon(PencilIcon, "bg-blue-600");
export const ColorfulTextCaseConverterIcon = ColorfulIcon(TextIcon, "bg-slate-600");
export const ColorfulLineNumberToolIcon = ColorfulIcon(TextIcon, "bg-slate-500");
export const ColorfulDuplicateRemoverIcon = ColorfulIcon(ScissorsIcon, "bg-red-500");
export const ColorfulTextSorterIcon = ColorfulIcon(SwapIcon, "bg-cyan-600");
export const ColorfulFrequencyCounterIcon = ColorfulIcon(SearchIcon, "bg-teal-600");
export const ColorfulTextReverserIcon = ColorfulIcon(SwapIcon, "bg-blue-400");
export const ColorfulRegexTesterIcon = ColorfulIcon(CodeBracketIcon, "bg-indigo-800");
export const ColorfulPdfBookletMakerIcon = ColorfulIcon(ImageIcon, "bg-red-700");
export const ColorfulRandomNumberGeneratorIcon = ColorfulIcon(CodeBracketIcon, "bg-slate-600");
export const ColorfulStopwatchTimerIcon = ColorfulIcon(GlobeIcon, "bg-orange-500");
export const ColorfulCsvExcelProcessorIcon = ColorfulIcon(CodeBracketIcon, "bg-green-600");
export const ColorfulZipToolIcon = ColorfulIcon(ZipIcon, "bg-yellow-600");
export const ColorfulDuplicateFileFinderIcon = ColorfulIcon(SearchIcon, "bg-slate-600");
export const ColorfulBatchFileRenamerIcon = ColorfulIcon(PencilIcon, "bg-blue-600");
export const ColorfulPdfPageExtractorIcon = ColorfulIcon(ScissorsIcon, "bg-red-500");
export const ColorfulImageCollageMakerIcon = ColorfulIcon(ImageIcon, "bg-pink-500");
export const ColorfulImageResizerIcon = ColorfulIcon(ImageIcon, "bg-cyan-500");
export const ColorfulQrCodeReaderIcon = ColorfulIcon(SearchIcon, "bg-cyan-400");
export const ColorfulPolaroidIcon = ColorfulIcon(ImageIcon, "bg-amber-700");
export const ColorfulRandomCountryIcon = ColorfulIcon(GlobeIcon, "bg-emerald-600");
export const ColorfulRobotsTxtIcon = ColorfulIcon(CodeBracketIcon, "bg-slate-800");
export const ColorfulSitemapGeneratorIcon = ColorfulIcon(GlobeIcon, "bg-sky-600");
export const ColorfulAiTextDetectorIcon = ColorfulIcon(SparklesIcon, "bg-purple-700");
export const ColorfulCreditCardGeneratorIcon = ColorfulIcon(CodeBracketIcon, "bg-slate-700");
export const ColorfulCreditCardValidatorIcon = ColorfulIcon(CheckIcon, "bg-green-600");
export const ColorfulLoremIpsumIcon = ColorfulIcon(TextIcon, "bg-slate-400");
export const ColorfulWhoisIcon = ColorfulIcon(SearchIcon, "bg-indigo-600");
export const ColorfulPinterestIcon = ColorfulIcon(DownloadIcon, "bg-red-600");
export const ColorfulInstagramIcon = ColorfulIcon(DownloadIcon, "bg-pink-600");
export const ColorfulTikTokIcon = ColorfulIcon(DownloadIcon, "bg-black");
export const ColorfulTwitterIcon = ColorfulIcon(DownloadIcon, "bg-sky-500");
export const ColorfulYoutubeDownloaderIcon = ColorfulIcon(DownloadIcon, "bg-red-600");

// Re-export specific identifiers required by App.tsx imports
export const ColorfulTrendIcon = ColorfulYoutubeTrendIcon;
export const ColorfulTagIcon = ColorfulYoutubeTagExtractorIcon;
export const ColorfulTitleIcon = ColorfulYoutubeTitleExtractorIcon;
export const ColorfulDescIcon = ColorfulYoutubeDescriptionExtractorIcon;
export const ColorfulAreaIcon = ColorfulUnitConverterIcon;
export const ColorfulWeightIcon = ColorfulWeightConverterIcon;
export const ColorfulVolumeIcon = ColorfulUnitConverterIcon;
export const ColorfulTempIcon = ColorfulTemperatureConverterIcon;
export const ColorfulAngleIcon = ColorfulUnitConverterIcon;
export const ColorfulTimeIcon = ColorfulTimeConverterIcon;
export const ColorfulDigitalIcon = ColorfulDigitalStorageConverterIcon;
export const ColorfulSpeedIcon = ColorfulSpeedConverterIcon;
export const ColorfulPaceIcon = ColorfulUnitConverterIcon;
export const ColorfulPartsIcon = ColorfulUnitConverterIcon;
export const ColorfulPressureIcon = ColorfulUnitConverterIcon;
export const ColorfulVoltageIcon = ColorfulUnitConverterIcon;
export const ColorfulCurrentIcon = ColorfulUnitConverterIcon;
export const ColorfulPowerIcon = ColorfulUnitConverterIcon;
export const ColorfulApparentIcon = ColorfulUnitConverterIcon;
export const ColorfulReactiveIcon = ColorfulUnitConverterIcon;
export const ColorfulEnergyIcon = ColorfulUnitConverterIcon;
export const ColorfulREnergyIcon = ColorfulUnitConverterIcon;
export const ColorfulFlowIcon = ColorfulUnitConverterIcon;
export const ColorfulIllumIcon = ColorfulUnitConverterIcon;
export const ColorfulPercIcon = ColorfulPercentageCalculatorIcon;
export const ColorfulAverageIcon = ColorfulCalculatorIcon;
export const ColorfulGstIcon = ColorfulCalculatorIcon;
export const ColorfulBmiIcon = ColorfulCalculatorIcon;
export const ColorfulCpmIcon = ColorfulCalculatorIcon;
export const ColorfulConfIcon = ColorfulCalculatorIcon;
export const ColorfulDiscIcon = ColorfulCalculatorIcon;
export const ColorfulMarginIcon = ColorfulCalculatorIcon;
export const ColorfulPpIcon = ColorfulCalculatorIcon;
export const ColorfulProbIcon = ColorfulCalculatorIcon;
export const ColorfulTaxIcon = ColorfulCalculatorIcon;
export const ColorfulPrivacyIcon = ColorfulPdfSecurityIcon;
export const ColorfulTermsIcon = ColorfulPdfSecurityIcon;
export const ColorfulSitemapIcon = ColorfulAboutIcon;
export const ColorfulBlogIcon = ColorfulAboutIcon;
export const ColorfulWordToPdfIcon = ColorfulTextEditorIcon;
export const ColorfulExcelToPdfIcon = ColorfulCsvExcelProcessorIcon;
export const ColorfulPptToPdfIcon = ColorfulPptIcon;
export const ColorfulHtmlToPdfIcon = ColorfulHtmlIcon;
export const ColorfulRotateIcon = ColorfulRotateImageIcon;
export const ColorfulPageNumIcon = ColorfulPdfBookletMakerIcon;
export const ColorfulCompressIcon = ColorfulImageCompressorIcon;
export const ColorfulRepairIcon = ColorfulPdfRepairIcon;
export const ColorfulPdfToTextIcon = ColorfulTextEditorIcon;
export const ColorfulBookletIcon = ColorfulPdfBookletMakerIcon;
export const ColorfulPageExtractIcon = ColorfulPdfPageExtractorIcon;
export const ColorfulPdfRedactorIcon = ColorfulIcon(LockClosedIcon, "bg-rose-600");
export const ColorfulPdfImageExtractorIcon = ColorfulIcon(ImageIcon, "bg-emerald-600");
export const ColorfulPdfGrayscaleIcon = ColorfulIcon(LayersIcon, "bg-slate-700");
export const ColorfulPdfMetadataIcon = ColorfulIcon(PencilIcon, "bg-indigo-600");
export const ColorfulInstagramGridIcon = ColorfulIcon(LayersIcon, "bg-pink-600");
export const ColorfulImageBlurIcon = ColorfulIcon(LockClosedIcon, "bg-indigo-600");
export const ColorfulCssGlassIcon = ColorfulIcon(SparklesIcon, "bg-purple-600");
export const ColorfulTweetIcon = ColorfulIcon(SparklesIcon, "bg-sky-500");
export const ColorfulFancyFontIcon = ColorfulIcon(PencilIcon, "bg-pink-600");
export const ColorfulAudioCutterIcon = ColorfulIcon(DownloadIcon, "bg-teal-600");
export const ColorfulDiffIcon = ColorfulIcon(CodeBracketIcon, "bg-cyan-600");
export const ColorfulJwtIcon = ColorfulIcon(LockClosedIcon, "bg-purple-600");
export const ColorfulCurlIcon = ColorfulIcon(CodeBracketIcon, "bg-indigo-600");
export const ColorfulCronIcon = ColorfulIcon(SparklesIcon, "bg-amber-600");
export const ColorfulFreelanceRateIcon = ColorfulIcon(SparklesIcon, "bg-emerald-600");
export const ColorfulFuelTripIcon = ColorfulIcon(SparklesIcon, "bg-cyan-600");
export const ColorfulAiHumanizerIcon = ColorfulIcon(SparklesIcon, "bg-indigo-600");
export const ColorfulSerpIcon = ColorfulIcon(SearchIcon, "bg-amber-600");
export const ColorfulSlugIcon = ColorfulIcon(LinkIcon, "bg-emerald-600");
export const ColorfulDnsIcon = ColorfulIcon(GlobeIcon, "bg-cyan-600");
export const ColorfulSslIcon = ColorfulIcon(LockClosedIcon, "bg-emerald-600");
export const ColorfulHttpHeaderIcon = ColorfulIcon(CodeBracketIcon, "bg-indigo-600");
